/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import store from "../../../store/store";

let items = [];

if (store.getters["auth/authenticated"]) {
  items = [
    {
      url: "/shop",
      name: "Lieferdienst",
      slug: "shop",
      icon: "ShoppingCartIcon",
    },
    {
      url: "/faq",
      name: "FAQ",
      slug: "faq",
      icon: "UsersIcon",
    },
    {
      url: "/profil",
      name: "profil",
      slug: "profil",
      icon: "PhoneIcon",
    },
  ];
} else {
  items = [
    {
      url: "/shop",
      name: "Lieferdienst",
      slug: "shop",
      icon: "ShoppingCartIcon",
    },
    {
      url: "/faq",
      name: "FAQ",
      slug: "faq",
      icon: "UsersIcon",
    },
  ];
}

export default items;
